import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { Path } from "@faire/web--source/common/Path";
import { trackSignupOpenModalClick } from "@faire/web-api--source/events/signup/click/openModal";
export function getSignUpLink(type, location) {
    return new Path(location).replace({
        signUp: type
    }).toString();
}
export function trackSignUpClick(type, element, sourceId) {
    var location = getLocationOrThrow();
    var signUpType = type === SignUpType.GENERIC ? "generic" : type;
    trackSignupOpenModalClick(signUpType, location.pathname + location.search, sourceId !== null && sourceId !== void 0 ? sourceId : "", element);
}
